import React from "react";

type OnOptionStateChange = (active, value) => void;

const DropdownOption = ({
	active = false,
	title,
	value,
	onStateChange = null
}: {
active?: boolean;
title: string;
value: string | number;
onStateChange?: OnOptionStateChange;
}) => {
	return (
		<div
			className={`filterOption ${active ? "active" : null}`}
			onClick={() => {
				if (onStateChange) {
					onStateChange(!active, value);
				}
			}}
		>
			<div className="icon" />
			<div className="label">{title}</div>
		</div>
	);
};

export default DropdownOption;
